'use strict';

const XStringUtils = require('./util/XStringUtils');

module.exports = {
    XStringUtils,
};